import DocsIcon from '@material-ui/icons/Description';
import { useEntity, getEntityRelations } from '@backstage/plugin-catalog-react';
import { RELATION_API_PROVIDED_BY } from '@backstage/catalog-model';
import { TECHDOCS_ANNOTATION, TECHDOCS_EXTERNAL_ANNOTATION } from '@backstage/plugin-techdocs-common';

// O botão padrão do TechDocs (useTechdocsReaderIconLinkProps, dentro de
// @backstage/plugin-techdocs) sempre aponta para a própria entidade da
// página atual (namespace/kind/name). Uma entidade API nunca tem
// documentação publicada por conta própria neste portal: o pipeline só
// publica TechDocs sob default/component/<app> (ver publish-docs em
// infra/argo-workflows/templates/product-api-pipeline.yaml), nunca sob
// default/api/<nome>. Sem este ajuste, o botão fica sempre desativado na
// página de qualquer API.
//
// Aqui, quando a entidade é uma API com relação apiProvidedBy (calculada
// automaticamente pelo catálogo a partir de providesApis no Component),
// o link usa o Component que a fornece. Para qualquer outra entidade
// (Component, Resource, API sem provider etc.), o comportamento é
// idêntico ao padrão do Backstage.
export function useTechdocsReaderIconLinkPropsWithProvider() {
  const { entity } = useEntity();
  const isApi = entity.kind.toLowerCase() === 'api';
  const [provider] = isApi
    ? getEntityRelations(entity, RELATION_API_PROVIDED_BY)
    : [];

  if (provider) {
    const { namespace, kind, name } = provider;
    return {
      label: 'View TechDocs',
      disabled: false,
      icon: <DocsIcon />,
      href: `/docs/${namespace}/${kind}/${name}`.toLowerCase(),
    };
  }

  const hasTechdocs = Boolean(
    entity.metadata.annotations?.[TECHDOCS_ANNOTATION] ||
      entity.metadata.annotations?.[TECHDOCS_EXTERNAL_ANNOTATION],
  );
  const namespace = entity.metadata.namespace ?? 'default';
  return {
    label: 'View TechDocs',
    disabled: !hasTechdocs,
    icon: <DocsIcon />,
    href: hasTechdocs
      ? `/docs/${namespace}/${entity.kind}/${entity.metadata.name}`.toLowerCase()
      : undefined,
  };
}
